var _rect, _rect2, _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddAutoAlertKeywordBtnIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Keyword",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1206",
    "data-name": "Rectangle 1206",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1207",
    "data-name": "Rectangle 1207",
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    d: "M9.8,2.66h0a7.771,7.771,0,1,0,7.04,10.85",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_981-2",
    d: "M16.34,6.37a7.763,7.763,0,0,0-1.96-2.15",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    d: "M15.51,15.97l5.44,5.32",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "key-outline",
    d: "M15.82,7.11a3.657,3.657,0,0,0-.72.91c-2.04.18-7.42.67-7.87.66a.626.626,0,0,0-.47.19,1.044,1.044,0,0,0-.25.68c0,.29.05,1.48.28,1.48.66,0,.82-.02,1.09-.02.41,0,.59-.64.83-.74a.441.441,0,0,1,.5.04c.15.1.28.4.46.58a.787.787,0,0,0,.62.21.665.665,0,0,0,.53-.16c.2-.19.17-.74.59-.73s.39.65.64.84a1.177,1.177,0,0,0,1,.04c.16-.11.21-.73.45-.88a.687.687,0,0,1,.49,0c.12.07.4.69.52.77a2.724,2.724,0,0,0,.61.15,3.622,3.622,0,0,0,.85,1.24,3.746,3.746,0,0,0,5.3.05,3.737,3.737,0,0,0-.16-5.29,3.676,3.676,0,0,0-5.25,0Zm4.5,3.41a.983.983,0,1,1-.01-1.39A.981.981,0,0,1,20.32,10.52Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.02
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(11.62 2.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAutoAlertKeywordBtnIcon);
export default __webpack_public_path__ + "static/media/add-auto-alert-keyword-btn-icon.38880d69735a68bf52960b79539636e8.svg";
export { ForwardRef as ReactComponent };